import { useClipboard as C } from "@vueuse/core";
import { ElMessage as d } from "element-plus";
import { useI18n as _ } from "vue-i18n";
import { resolveComponent as b, openBlock as n, createElementBlock as l, renderSlot as p, createElementVNode as g, Fragment as y, createBlock as f, createCommentVNode as S } from "vue";
import { _ as v } from "../_plugin-vue_export-helper-dad06003.js";
const B = {
  name: "rClipboard",
  props: {
    /**
     * 复制内容
     */
    text: {
      type: String,
      required: !0
    },
    /**
     * 静默模式
     */
    slient: {
      type: Boolean,
      default: !1
    },
    /**
     * 复制成功后icon改为success的icon
     */
    iconChangeOnSuccess: {
      type: Boolean,
      default: !0
    }
  },
  emits: {
    /**
     * 复制成功
     */
    success: null,
    /**
     * 复制失败
     */
    error: null
  },
  methods: {},
  setup(e, { emit: o }) {
    const { t: r } = _(), { text: s, copy: m, copied: i, isSupported: t } = C({
      source: e.text || ""
    }), a = (c) => {
      e.slient || d({
        type: "success",
        message: r("bmui-clipboard.success")
      }), o("success", c);
    }, k = (c) => {
      e.slient || d({
        type: "error",
        message: r("bmui-clipboard.error")
      }), o("error", c);
    };
    return {
      onCopy: () => {
        try {
          m(), i && a();
        } catch (c) {
          k(c);
        }
      },
      isSupported: t,
      copied: i
    };
  }
}, I = {
  key: 0,
  class: "r-copy"
};
function h(e, o, r, s, m, i) {
  const t = b("r-icon");
  return s.isSupported ? (n(), l("span", I, [
    p(e.$slots, "default"),
    g("span", {
      onClick: o[0] || (o[0] = (...a) => s.onCopy && s.onCopy(...a))
    }, [
      !s.copied || !r.iconChangeOnSuccess ? (n(), l(
        y,
        { key: 0 },
        [
          e.$slots.copyIcon ? p(e.$slots, "copyIcon", { key: 0 }) : (n(), f(t, {
            key: 1,
            class: "r-copy-icon",
            name: "icon-actions_edit_copy1"
          }))
        ],
        64
        /* STABLE_FRAGMENT */
      )) : (n(), l(
        y,
        { key: 1 },
        [
          e.$slots.successIcon ? p(e.$slots, "successIcon", { key: 0 }) : (n(), f(t, {
            key: 1,
            class: "r-copy-icon",
            name: "icon-copy-success"
          }))
        ],
        64
        /* STABLE_FRAGMENT */
      ))
    ])
  ])) : S("v-if", !0);
}
const u = /* @__PURE__ */ v(B, [["render", h], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/clipboard/clipboard.vue"]]);
u.install = function(e) {
  e.component(u.name, u);
};
export {
  u as default
};
